import React from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { useParams } from 'react-router-dom'
import FormBuilder from './layout-builder'
import { FileContextProvider } from '../fileContext/fileContext'
import { PopupCloseContextProvider } from './contexts/popupclose-context'
import './form-engine.css'

const FormBuilderContainer: React.FC = () => {
  const { formType } = useParams<{ formType?: string }>()
  return (
    <PopupCloseContextProvider>
      <FileContextProvider>
        <DndProvider backend={HTML5Backend}>
          <FormBuilder key={formType ?? 'default'} formType={formType} />
        </DndProvider>
      </FileContextProvider>
    </PopupCloseContextProvider>
  )
}

export default FormBuilderContainer
